import { updateState } from '@/store/extensions/update';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  ...updateState,
  currentCompany: null,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/company/index.js